<template>
    <div>
        <router-view/>
        <notifications :duration="6000" />
        <modals />
    </div>
</template>

<script>

    export default {
        name: "Form",
    }
</script>

<style scoped>

</style>